import ApiService from "./ApiService";
import {
	CriteriaManifestationsAddClassificationsRequest,
	CriteriaManifestationsAddClassificationsResponse,
	CriteriaManifestationsAddGroupsRequest,
	CriteriaManifestationsAddGroupsResponse,
	CriteriaManifestationsDeleteRequest,
	CriteriaManifestationsDeleteResponse,
	CriteriaManifestationsGetResponse,
	CriteriaManifestationsPostRequest,
	CriteriaManifestationsPostResponse,
	CriteriaManifestationsPutRequest,
	CriteriaManifestationsPutResponse,
} from "src/entities/CriteriaManifestationEntity";

export const criteriaManifestationQueryKeys = {
	manifestations: (id: string) => ["criteria", id, "manifestations"] as const,
};

export default class CriteriaManifestationService extends ApiService {
	public async getManifestations(criteriaId: number) {
		return await this.request.get<CriteriaManifestationsGetResponse>(`/api/v1/criteria/${criteriaId}/manifestations`);
	}
	public async postManifestations(data: CriteriaManifestationsPostRequest) {
		return await this.request.post<CriteriaManifestationsPostResponse>(`/api/v1/criteria/manifestations`, data);
	}
	public async putManifestations(data: CriteriaManifestationsPutRequest) {
		return await this.request.put<CriteriaManifestationsPutResponse>(`/api/v1/criteria/manifestations`, data);
	}
	public async deleteManifestations(data: CriteriaManifestationsDeleteRequest) {
		return await this.request.post<CriteriaManifestationsDeleteResponse>(`/api/v1/criteria/manifestations/delete`, data);
	}
	public async postManifestationClassifications(data: CriteriaManifestationsAddClassificationsRequest) {
		return await this.request.post<CriteriaManifestationsAddClassificationsResponse>(`/api/v1/criteria/manifestations/classifications`, data);
	}
	public async deleteManifestationClassification(manifestationId: number, classificationId: number) {
		return await this.request.delete(`/api/v1/criteria/manifestations/${manifestationId}/classifications/${classificationId}`);
	}
	public async postManifestationGroups(data: CriteriaManifestationsAddGroupsRequest) {
		return await this.request.post<CriteriaManifestationsAddGroupsResponse>(`/api/v1/criteria/manifestations/groups`, data);
	}
	public async deleteManifestationGroup(manifestationId: number, groupId: number) {
		return await this.request.delete(`/api/v1/criteria/manifestations/${manifestationId}/groups/${groupId}`);
	}
}
